import { render, staticRenderFns } from "./TextAreaStyle.vue?vue&type=template&id=bcfc3304&"
import script from "./TextAreaStyle.vue?vue&type=script&lang=js&"
export * from "./TextAreaStyle.vue?vue&type=script&lang=js&"
import style0 from "./TextAreaStyle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports